/**
 * Cookie Service Utility
 * Provides helper functions for reading, setting, and removing browser cookies.
 */

export const cookieService = {
  getCookie: (name: string): string | null => {
    try {
      const nameEQ = name + '=';
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
      return null;
    } catch (error) {
      console.error('Error reading cookie:', error);
      return null;
    }
  },

  setCookie: (name: string, value: string, days = 7): void => {
    try {
      const expires = new Date(Date.now() + days * 864e5).toUTCString();
      document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
    } catch (error) {
      console.error('Error setting cookie:', error);
    }
  },

  removeCookie: (name: string): void => {
    try {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    } catch (error) {
      console.error('Error removing cookie:', error);
    }
  },
};
